import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import auth from './modules/auth'
import bundle from './modules/bundle'
import common from './modules/common'
import company from './modules/company'
import floorplan from './modules/floorplan'
import hotspot from './modules/hotspot'
import ipackage from './modules/ipackage'
import item from './modules/item'
import payments from './modules/payments'
import project from './modules/project'
import stepper from './modules/stepper'
import term from './modules/term'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    auth,
    bundle,
    common,
    company,
    floorplan,
    hotspot,
    ipackage,
    item,
    payments,
    project,
    stepper,
    term
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js